import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LoaderService {
  isLoaderOn = new BehaviorSubject<boolean | null>(null);

  constructor() {
  }
}
